import styled from 'styled-components';

export const GroupOptions = styled.div`
	display: flex;
	padding-right: 1em;
	box-sizing: border-box;
	max-width: 300px;
`;

export default GroupOptions;